import React from 'react'

import Center from './Center'
import IconBlock from '../presentation/IconBlock'
import { globalHistory, navigate } from '@reach/router'
import Button from '../../packages/kiti/components/actions/Button'

export class ControledErrorMessage extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: false }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidMount() {
    this.unlisten = globalHistory.listen((location, action) => {
      if (this.state.error) {
        this.setState({ error: false })
      }
    })
  }

  componentWillUnmount() {
    this.unlisten()
  }

  componentDidCatch(error, errorInfo) {
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.error) {
      return <ErrorView error={this.state.error} {...this.props} />
    }

    return this.props.children
  }
}

const goHome = () => {
  navigate('/')
  window.location.reload(false)
}

export const ErrorView = ({ error, title, message }) => {
  return (
    <Center>
      <IconBlock
        icon="BsExclamationTriangle"
        title={title || 'Parece que ocorreu um erro inesperado!'}
        subtitle={
          message ||
          'Estamos trabalhando para resolver. Você pode entrar em contato pelo nosso chat de suporte ao cliente para saber mais sobre o que pode ter acontecido.'
        }
        text={error && error.message}
      />
      <Button bold onClick={goHome}>
        Ir para a tela inicial
      </Button>
    </Center>
  )
}

export default ControledErrorMessage
